import React, { useState} from "react";
import {EngineerApp} from "./EngineerApp";
import JobManagment from "./JobManagement";
import EngineerManagment from "./EngineerManagement";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import {Login} from "./login/login";
import Logout from "./logout/logout";

export const App = () => {
    
    const[user, setCurrentUser] = useState({});

    return (
        <Router>
            <Switch>
                <Route path="/login">
                    <Login setUser={(user) => setCurrentUser(user)} />
                </Route>
                <Route path="/engineer/:engineerId">
                    <EngineerApp engineer={user} />
                </Route>
                <Route path="/manage/jobs">
                    <JobManagment user={user} />
                </Route>
                <Route path="/manage/engineers">
                    <EngineerManagment user={user} />
                </Route>
                <Route path="/logout">
                    <Logout logout={() => setCurrentUser({})} />
                </Route>
                <Route path="/">
                    <Redirect to="/login" />
                </Route>
            </Switch>
        </Router>);
}